import { useEffect } from 'react';
import Alert from '@mui/material/Alert';
import { useNavigate } from 'react-router-dom';
import Container from 'components/common/Container';
import CustomLink from 'components/common/CustomLink';
import { loadSession, useAuth } from 'utils/auth';
import Signup from './Signup';

export default function NusSignIn() {
  const { session } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (session?.status === 'authenticated') {
      window.myAntsTag?.('SET', 'userId', String(session.user.userId));
      window.myAntsTag?.('EVENT', 'LOGIN');
      navigate('/data', { replace: true });
    }
  }, [session, navigate]);

  // Registration rotates the session and CSRF token on the backend.
  const complete = async () => {
    const updated = await loadSession(true);
    if (updated?.status !== 'authenticated') throw new Error('Sign-in expired');
  };

  if (session?.status === 'profile_required') {
    return <Signup nusEmail={session.email} onComplete={complete} />;
  }
  if (session?.status === 'authenticated') return null;
  return (
    <Container style={{ marginTop: 48, marginBottom: 48 }}>
      <Alert severity='error'>
        Your NUS sign-in has expired.{' '}
        <CustomLink to='/login'>Log in again</CustomLink>.
      </Alert>
    </Container>
  );
}
